import {createMuiTheme} from '@material-ui/core/styles'

const muiTheme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: {
      main: 'rgb(25,145,255)',
    },
    secondary: {
      main: 'rgb(215,80,145)',
    },
    error: {
      main: 'rgb(255,70,70)',
    },
    text: {
      primary: 'rgb(15,40,70)',
      secondary: 'rgb(15,40,70)',
      disabled: 'rgb(180,190,210)',
    },
    action: {
      active: 'rgb(15,40,70)',
      hover: 'rgb(234,237,241)',
      selected: 'rgb(180,190,210)',
      hoverOpacity: 0.05,
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
})

export default muiTheme
